type FilterType = 'text' | 'taginput' | 'select-multiple' | 'account-selector' | 'account-bo-selector' | 'account-broker-selector' | 'region-level-1' | 'region-level-2' | 'date-range';

interface AccountSelectorValue {
  id: number | string;
  [key: string]: any;
}

interface FilterItem {
  key: string;
  type: FilterType;
  value: string | string[] | AccountSelectorValue[];
}

type ParsedFilter = Record<string, any>;

export const parseFilter = (filterData: FilterItem[] | undefined | null): ParsedFilter => {
  if (Array.isArray(filterData) && filterData.length > 0) {
    return filterData.reduce<ParsedFilter>((acc, item) => {
      return { ...acc, ...getFilterItem(item) };
    }, {});
  }
  return {};
};

function getFilterItem(item: FilterItem): ParsedFilter {
  switch (item.type) {
    case 'account-selector':
    case 'account-bo-selector':
    case 'account-broker-selector':
    case 'region-level-1':
    case 'region-level-2':
      return getValueByAccountSelectorType(item);
    case 'date-range':
      return getValueByDateRange(item);
    case 'text':
    case 'taginput':
    case 'select-multiple':
    default:
      return getValueByDefaultType(item);
  }
}

function getValueByDefaultType(item: FilterItem): ParsedFilter {
  return { [item.key]: item.value };
}

function getValueByAccountSelectorType(item: FilterItem): ParsedFilter {
  const value = Array.isArray(item.value)
    ? item.value.map((i: any) => i?.id).filter(Boolean)
    : [];
  return { [item.key]: value };
}

function getValueByDateRange(item: FilterItem): ParsedFilter {
  return { [item.key]: item.value };
}
